// Shared constants for reporting components

// Chart configuration
export const CHART_DEFAULTS = {
  barThickness: {
    // Slightly slimmer bars for deck readability (less “chart-first”).
    sm: 14,
    md: 16,
    lg: 24,
    xl: 24,
  },
  // Apply a subtle alpha to fills so shapes don't feel "heavy".
  fillAlpha: 0.88,
  tickFontSize: {
    sm: 10,
    md: 11,
    lg: 12,
  },
  legendFontSize: {
    sm: 10,
    md: 12,
    lg: 14,
  },
  legendFontWeight: 700,
} as const

// Chart palette from CSS variables
export const CHART_PALETTE = [
  'var(--slide-chart-1)',
  'var(--slide-chart-2)',
  'var(--slide-chart-3)',
  'var(--slide-chart-4)',
  'var(--slide-chart-5)',
  'var(--slide-chart-6)',
] as const

// Neutral palette for monochrome bar/series usage (e.g., root-cause bars)
export const NEUTRAL_CHART_PALETTE = [
  'var(--slide-text-primary)',
  'var(--slide-text-muted)',
  'var(--slide-neutral-mid)',
  'var(--slide-border)',
] as const
